import { PlantMark } from "@/app/components/PlantMark";
import type { Plant } from "@/types";

/**
 * A compact, overlapping row of plant avatars (photo or colored initial tile).
 * Each avatar is a button that opens its plant. Renders nothing for an empty list.
 */
export function PlantAvatarGroup({ plants, onPlantClick, className = "" }: Readonly<{
  plants: Plant[];
  onPlantClick: (id: string) => void;
  className?: string;
}>) {
  if (plants.length === 0) return null;
  return (
    <div className={`flex items-center ${className}`}>
      {plants.map((plant, i) => (
        <button
          key={plant.id}
          onClick={() => onPlantClick(plant.id)}
          aria-label={plant.nickname}
          className={`relative ${i === 0 ? "" : "-ml-2"} rounded-[10px] ring-2 ring-paper bg-transparent border-0 p-0 cursor-pointer transition-transform duration-150 hover:z-10 hover:-translate-y-0.5`}
        >
          <PlantMark plant={plant} size={28} />
        </button>
      ))}
    </div>
  );
}
